import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEllipsisV } from "react-icons/fa";
import { Col } from "react-bootstrap";
function QuotationCard({ type }) {
  const [dropShow, setDropShow] = useState(false);
  const navigate = useNavigate();

  const quoCardClickHandler = (e) => {
    navigate("/enquiry/create-quotation", {
      state: { type: `${type}` },
    });
  };

  const dropHandler = () => {
    setDropShow(!dropShow);
  };

  return (
    <div className="my-4">
      <div className="enquiry-list-card-cont p-0">
        <div className="position-absolute enq-drop-whole-container">
          <button
            className="cust-btn dropdown-container-tool p-0"
            onClick={dropHandler}
          >
            <FaEllipsisV />
          </button>
          {dropShow && (
            <div className="enq-sort-drop">
              <Link>View</Link>
              <Link>Delete</Link>
            </div>
          )}
        </div>

        <div onClick={quoCardClickHandler} style={{ cursor: "pointer" }}>
          <div className="d-flex gap-4 flex-wrap fnt-fam-f1 py-1 mt-2 px-3">
            <p className="fs-14px">
              <span className="opac_half">Quotation ID:</span> P00001
            </p>
            <p className="fs-14px">
              <span className="opac_half">Quotation RefNo:</span> P00001
            </p>
            <p className="fs-14px">
              <span className="opac_half">Quotation Date</span> 14-01-2023
            </p>
            <p className="fs-14px">
              <span className="opac_half">RFQ ID:</span> P00001
            </p>

            <p className="fs-14px">
              <span className="opac_half">RFQ Date:</span> 01-12-2022
            </p>
          </div>
          <p className="text-uppercase fw-bold py-1 px-3 enuiryfont">
            Fortune promoseven llc (A division of NUkhaba press disbution and
            release)
          </p>
          <p className="py-1 mb-2 px-3">
            {type == "primary" && (
              <button
                type="button"
                className="btn btn-outline-primary po-card-btn fnt-fam-f2 fs-15px"
              >
                Responded
              </button>
            )}
            {type == "success" && (
              <button
                type="button"
                className="btn btn-outline-success po-card-btn fnt-fam-f2 fs-15px"
              >
                Awaraded
              </button>
            )}
            {type == "danger" && (
              <button
                type="button"
                className="btn btn-outline-danger po-card-btn fnt-fam-f2 fs-15px"
              >
                Decline
              </button>
            )}
            {type == "warning" && (
              <button
                type="button"
                className="btn warning-button po-card-btn fnt-fam-f2 fs-15px"
              >
                Yet to Respond
              </button>
            )}
          </p>
          <div className="opac_half d-flex gap-3 align-items-center enquiry-footer-card p-2 flex-wrap">
            <p className="fnt-fam-f2 fs-14px">
              <span>Quotation Value:</span>2514
            </p>
            <p className="fnt-fam-f2 fs-14px">
              <span>Validate date:</span>12-01-2023
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuotationCard;
